const privacyOptions = [
  { value: 'team_view', label: 'Team View' },
  { value: 'team_edit', label: 'Team Edit' },
  { value: 'private', label: 'Private' },
  { value: 'global_view', label: 'Global View' },
]

export { privacyOptions }
